import IcoMoon, { IconProps } from 'react-icomoon';
import { ICON_SOURCE } from 'common/types/icon-source';
import iconSet from './json/youling.json';
import iconSet2 from './json/youling-panel-icons.json';

const SOURCE = 'eevee-icon';

const iconSource = {
  [ICON_SOURCE.GENERATERSOURCE]: SOURCE,
  [ICON_SOURCE.ICONS]: [...iconSet.icons, ...iconSet2.icons],
};

const EeveeIcon = (props: IconProps) => <IcoMoon iconSet={iconSource} size={props.size || '1em'} {...props} />;

export default EeveeIcon;
